module.exports = __webpack_public_path__ + "img/5.c1e3bb41.svg";